/**
 * Created by Administrador on 26/10/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('reportService', reportService);

    reportService.$inject = ['$http', 'CONFIG', 'messageService'];

    function reportService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/reports';
        var service = {
            getGeneralManifest: getGeneralManifest,
            getGeneralManifestPdf: getGeneralManifestPdf,
            getLuggageManifestPdf: getLuggageManifestPdf,
            getSsrManifestPdf: getSsrManifestPdf,
            getPassengerManifestPdf: getPassengerManifestPdf,
            getCargoManifest: getCargoManifest,
            getCargoManifestPdf: getCargoManifestPdf,
            getNotocManifestPdf: getNotocManifestPdf,
            getPaymentWeight: getPaymentWeight,
            getPaymentWeightPdf: getPaymentWeightPdf
        }

        return service;

        function getGeneralManifest(departureFlightId,manifestType,flightId,departureFlightOrder,orderBy){
            return $http.get(urlBase +'/generalManifest?departureFlightId='+departureFlightId+'&manifestType='+manifestType+
            '&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder+'&orderBy='+orderBy)
                .then(function(response){
                    return response;
                })
                .catch(function(e){
                    if( e.status === 400 && e.data.message && (e.data.message.indexOf('There is no data') >=0) ) {
                        messageService.findAllEmpty('');
                    } else {
                        messageService.findAllError('');
                    }
                });
        }

        function getGeneralManifestPdf(departureFlightId,reducedPrint,flightId,departureFlightOrder,orderBy){
            return $http.get(urlBase +'/generalManifest/pdf?departureFlightId='+departureFlightId+
                "&reducedPrint="+reducedPrint+'&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder+'&orderBy='+orderBy,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getLuggageManifestPdf(departureFlightId,reducedPrint){
            return $http.get(urlBase +'/luggageManifest/pdf?departureFlightId='+departureFlightId+"&reducedPrint="+reducedPrint,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getSsrManifestPdf(departureFlightId,reducedPrint){
            return $http.get(urlBase +'/ssrManifest/pdf?departureFlightId='+departureFlightId+"&reducedPrint="+reducedPrint,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getPassengerManifestPdf(departureFlightId,reducedPrint,orderBy){
            return $http.get(urlBase +'/passengerManifest/pdf?departureFlightId='+departureFlightId+"&reducedPrint="+reducedPrint+"&orderBy="+orderBy,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getCargoManifest(departureFlightId,flightId,departureFlightOrder){
            return $http.get(urlBase +'/cargoManifest?departureFlightId='+departureFlightId+
                '&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoManifestPdf(departureFlightId,reducedPrint,flightId,departureFlightOrder){
            return $http.get(urlBase +'/cargoManifest/pdf?departureFlightId='+departureFlightId+
                "&reducedPrint="+reducedPrint+'&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getNotocManifestPdf(departureFlightId,reducedPrint,flightId,departureFlightOrder){
            return $http.get(urlBase +'/notoc/pdf?departureFlightId='+departureFlightId+
                "&reducedPrint="+reducedPrint+'&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getPaymentWeight(departureFlightId,flightId,departureFlightOrder){
            return $http.get(urlBase +'/payWeight?departureFlightId='+departureFlightId+
                '&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPaymentWeightPdf(departureFlightId,flightId,departureFlightOrder){
            return $http.get(urlBase +'/payWeight/pdf?departureFlightId='+departureFlightId+
                '&flightId='+flightId+'&departureFlightOrder='+departureFlightOrder,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }
    }
})();
